import _ from 'lodash';
/**
 * body部のattributesをsingletonで保持
 */
class DocumentBodyState {
    constructor() {
        const bodyElement = document.querySelector('body');
        const getDataAttribute = (key) => {
            const result = _.get(bodyElement.attributes, `data-${key}.value`);
            bodyElement.removeAttribute(`data-${key}`);
            return result || '[]';
        };
        const themes = JSON.parse(getDataAttribute('top-search-themes'));
        const themeOptions = themes
            .filter((v) => !v.other)
            .map((v) => ({
            color: '#485C60',
            id: '',
            label: v.label,
            value: v.keyword,
        }));
        this.attributes = {
            // IFrameComponentのheadに読み込ませるためのCSSリンク
            cssLink: getDataAttribute('css-link'),
            // お知らせ
            news: {
                dataList: JSON.parse(getDataAttribute('top-news')),
            },
            // コンサルの各件数
            professional: {
                defaultCount: parseInt(getDataAttribute('default-professional-count'), 10),
                images: JSON.parse(getDataAttribute('professional-images')),
                totalCount: parseInt(getDataAttribute('total-professional-count'), 10),
            },
            // 案件数
            rfp: {
                totalCount: parseInt(getDataAttribute('total-rfps-count'), 10),
            },
            // セミナーの各件数
            seminar: {
                defaultCount: parseInt(getDataAttribute('default-seminar-count'), 10),
                totalCount: parseInt(getDataAttribute('total-seminar-count'), 10),
            },
            // ソリューション事例の各件数
            solution: {
                defaultCount: parseInt(getDataAttribute('default-solution-count'), 10),
                images: JSON.parse(getDataAttribute('solution-images')),
                totalCount: parseInt(getDataAttribute('total-solution-count'), 10),
            },
            themeOptions,
            // 検索用のテーマ一覧
            themes,
        };
    }
}
// singleton
export default new DocumentBodyState();
